import { FC } from 'react';

import { LegendItemData } from './types';

type LegendItemProps = {
  itemData: LegendItemData;
};

export const LegendItem: FC<LegendItemProps> = ({ itemData }) => {
  const { color, label, icon: Icon } = itemData;

  return (
    <div className="flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground">
      {Icon ? (
        <Icon />
      ) : (
        <div
          className="h-2 w-2 shrink-0 rounded-[2px]"
          style={{ backgroundColor: color }}
        />
      )}
      <span className="text-xs">{label}</span>
    </div>
  );
};
